import { toPascal, toCamel } from "../../utils/helpers";
import { handleResponse } from "src/services/apiServices";
import { trackPromise } from "react-promise-tracker";
import { ICivilDefense, IRequestToBMCData } from "../interfaces/ICivilDefense";
import { createSlice } from "@reduxjs/toolkit";
import {
  getBMCTemplatesAPI,
  sendRequestToBMCAPI,
  getBMCListAPI,
} from "src/api/civilDefenseAPI";

export const getBMCTemplates = (bmcId: string) => {
  return async (dispatch: any) => {
    return await trackPromise(getBMCTemplatesAPI(bmcId).then((res: any) => {
      dispatch(toCamel(setBMCTemplates(res?.data?.NotificationTemplates)));
    }));
  };
};

export const getBMCList = () => {
  return async (dispatch: any) => {
    return await trackPromise(getBMCListAPI().then((res: any) => {
      dispatch(toCamel(setBMCList(res?.data?.BMCs)));
    }));
  };
};

export const sendRequestToBMC = (onSuccess: Function) => {
  return async (dispatch: any, getState: any) => {
    const sendRequestToBMCData = getState().civilDefense.requestToBMCData;
    const payload = toPascal(sendRequestToBMCData);
    return await trackPromise(
      sendRequestToBMCAPI(payload)
        .then((response) => {
          onSuccess?.();
        })
        .catch((err: any) => {
          handleResponse(err);
        })
    );
  };
};

const initialState: ICivilDefense = {
  requestToBMCData: {
    bmcId: "",
    templateId: "",
    subject: "",
    body: "",
  },
  bmcTemplates: [],
  bmcList: [],
};

const civilDefense = createSlice({
  name: "civilDefense",
  initialState,
  reducers: {
    setBMCTemplates: (state, action) => {
      state.bmcTemplates = action.payload;
    },
    setBMCList: (state, action) => {
      state.bmcList = action.payload;
    },
    resetData: (state) => {
      state.requestToBMCData = initialState.requestToBMCData;
    },

    setSendRequestToBMCDetails: (state, action) => {
      state.requestToBMCData = action.payload;
    },
  },
});

export const {
  setBMCTemplates,
  setBMCList,
  setSendRequestToBMCDetails,
  resetData,
} = civilDefense.actions;
export default civilDefense.reducer;
